import { render, staticRenderFns } from "./PersonReasonForPresentation.vue?vue&type=template&id=7dcfe178&"
import script from "./PersonReasonForPresentation.vue?vue&type=script&lang=js&"
export * from "./PersonReasonForPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports